module.exports = __webpack_public_path__ + "assets/functionalityCloseSmall-f365ff.svg";